// src/analytics.js
export const gaEvent = (action, params = {}) => {
  if (window.gtag) window.gtag('event', action, params);
};

export const gaPageView = (path) => {
  if (window.gtag) window.gtag('event', 'page_view', { page_path: path });
};
